import { ComponentLoader } from '@bythepixel/component-loader';
import xhrModalLink from './xhrModalLink';
import TrailerAnimation from '../components/trailerAnimation';
import DealerLocatorForm from '../components/dealerLocatorForm';
import initDealerLocator from '../dealerLocator';

window.trailerBuildComponents = new ComponentLoader(document, [
  xhrModalLink,
  TrailerAnimation,
  DealerLocatorForm,
], () => {
  initDealerLocator();
});
